<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-2">
        <label>Data Inicial</label>
        <input type="date" class="form-control" v-model="filters.data_inicio" max="9999-12-31" />
      </div>
      <div class="col-md-2">
        <label>Data Final</label>
        <input type="date" class="form-control" v-model="filters.data_fim" max="9999-12-31" />
      </div>
      <div class="col-md-3">
        <label>Viatura</label>
        <input type="text" class="form-control" v-model="filters.viatura" placeholder="Digite a viatura" />
      </div>
      <div class="col-md-2 d-flex align-items-end">
        <button class="btn btn-primary w-100" @click="getVeiculos">Buscar</button>
      </div>
    </div>

    <div class="barras-container margin-top-grande">

      <div v-if="sortedSolicitacoes.length">
        <div v-for="item in sortedSolicitacoes" :key="item.nome" class="bar-row">
          <span class="bar-label">{{ item.nome }}</span>
          <div class="bar-container">
            <div class="bar" :style="{ width: (item.total / maxTotal * 100) + '%' }"></div>
            <span class="bar-value-outside" :style="{ left: `calc(${(item.total / maxTotal * 100)}% + 12px)` }">
              {{ item.total }}
            </span>
          </div>
        </div>

      </div>
      <div v-else class="text-center mt-4">Nenhum dado encontrado.</div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  components: {
    BaseCrud,
  },
  data() {
    const hoje = new Date().toISOString().split("T")[0];
    return {
      filters: {
        data_inicio: hoje,
        data_fim: hoje,
        viatura: "",
      },
      solicitacoes: [],
    };
  },
  computed: {
    sortedSolicitacoes() {
      return this.solicitacoes.slice().sort((a, b) => b.total - a.total);
    },
    maxTotal() {
      return this.sortedSolicitacoes.length
        ? Math.max(...this.sortedSolicitacoes.map((i) => i.total))
        : 1;
    },
  },
  methods: {
    getVeiculos() {
      let filtros = {
        data_inicio: this.filters.data_inicio,
        data_fim: this.filters.data_fim,
        viatura: this.filters.viatura,
      };
      let api = this.$store.state.api + "relatorio_veiculo";
      this.$loading(true);
      axios
        .post(api, filtros)
        .then((response) => {
          this.solicitacoes = Array.isArray(response.data)
            ? response.data
            : response.data.data || [];
          this.$loading(false);
        })
        .catch((error) => {
          this.$message(
            null,
            error.response?.data || "Erro ao buscar dados",
            "error"
          );
          this.$loading(false);
        });
    },
  },
  mounted() {
    this.getVeiculos();
  },
};
</script>

<style scoped>
.bar-row {
  display: flex;
  align-items: center;
  margin-bottom: 26px;
}

.bar-label {
  min-width: 400px;
  font-weight: bold;
  margin-right: 16px;
  color: #222;
  font-size: 1.0em;
}

.bar-container {
  flex: 1;
  max-width: 80vw;
  background: #f5f5f5;
  border-radius: 24px;
  height: 38px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: visible;
}


.bar {
  background: #4f81bd;
  height: 30px;
  border-radius: 24px;
  transition: width 0.4s;
  position: absolute;
  left: 0;
  top: 0;
}

.bar-value-outside {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.15em;
  font-weight: bold;
  color: #222;
  white-space: nowrap;
}

.margin-top-grande {
  margin-top: 80px;
}
</style>
